import { render, staticRenderFns } from "./SeverityCheckbox.vue?vue&type=template&id=26aeff68&"
import script from "./SeverityCheckbox.vue?vue&type=script&lang=js&"
export * from "./SeverityCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports